import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';

// Kontext
import { AuthProvider } from './context/AuthContext';

// Komponenty
import Login from './components/Login';
import Registration from './components/Registration';
import Profile from './components/Profile';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserReservation from './components/UserReservation';
import RegistrationChoice from './components/RegistrationChoice';
import LoginChoice from './components/LoginChoice';
import Contact from './components/Contact';
import ApiDoc from './components/ApiDoc';
import MainPage from './components/MainPage';
import TermsAndConditions from './components/TermsAndConditions';
import CookiesPage from './components/Cookies';
import Footer from './components/Footer';
import NotFound from './components/NotFound';

// Komponenty pro podnikatele
import BusinessLogin from './components/BusinessLogin';
import BusinessPublicProfile from './components/BusinessPublicProfile';
import AllPublicReservationForm from './components/AllPublicReservationForm';
import BusinessProfile from './components/BusinessProfile';
import BusinessAdminProfile from './components/BusinessAdminProfile';
import BusinessProfileReservation from './components/BusinessProfileReservation';
import PaymentForm from './components/PaymentForm';
import BusinessForgotPassword from './components/BusinessForgotPassword';
import BusinessResetPassword from './components/BusinessResetPassword';

//Podniky s vice pobockami 
import AdminPaymentForm from './components/AdminPaymentForm';
import BusinessProfileToAdmin from './components/BusinessProfileToAdmin';



// Cookies a Google Analytics
import usePageTracking from './components/usePageTracking';
import CookiesConsent from './components/CookiesConsent';

//Odhlaseni emailu 
import UnsubscribeEmail from "./components/UnsubscribeEmail"
import BusinessAllRegistration from './components/BusinessAllRegistration';

import IframeReservationForm from "./components/IframeReservationForm"
import IframeBasicReservation from './components/IframeBasicReservation';
import IframeBookingReservation from './components/IframeBookingReservation';
import IframeLessonsReservation from './components/IframeLessonsReservation';
import AdminMainPage from './components/AdminMainPage';
import IframeMainPage from './components/IframeMainPage';


// Komponenta pro sledování page view – musí být uvnitř <Router>
const PageTrackingWrapper = () => {
  usePageTracking();
  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <PageTrackingWrapper />
        <CookiesConsent />

        <Routes>
          {/* Uživatelské cesty */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/reservation" element={<UserReservation />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/registration-choice" element={<RegistrationChoice />} />
          <Route path="/login-choice" element={<LoginChoice />} />

          {/* Podnikatelé */}
          <Route path="/business/login" element={<BusinessLogin />} />
          <Route path="/business/register" element={<BusinessAllRegistration />} />
          <Route path="/business/profile" element={<BusinessProfile />} />
          <Route path="/business/profile/reservations" element={<BusinessProfileReservation />} />
          <Route path="/business/profile/paymentform" element={<PaymentForm />} />
          <Route path="/business/forgot-password" element={<BusinessForgotPassword />} />
          <Route path="/business/reset-password" element={<BusinessResetPassword />} />
          <Route path="/business/public/:businessId" element={<BusinessPublicProfile />} />
          <Route path="/business/public/:businessId/reservation" element={<AllPublicReservationForm />} />

          <Route path="/business/public/:businessId/reservationform" element={<IframeReservationForm />} />
          <Route path="/business/public/:businessId/basicreservation/reservationform" element={<IframeBasicReservation />} />
          <Route path="/business/public/:businessId/bookingreservation/reservationform" element={<IframeBookingReservation />} />
          <Route path="/business/public/:businessId/lessonsreservation/reservationform" element={<IframeLessonsReservation />} />
          <Route path="/business/public/:businessId/mainpage/reservationform" element={<IframeMainPage />} />


          <Route path="/business/admin-profile" element={<BusinessAdminProfile />} />
          <Route path="/business/admin-profile/:businessId" element={<BusinessProfileToAdmin />} />
          <Route path="/business/global-main-page/:businessId" element={<AdminMainPage />} />

          {/*Podnikatele s vice pobockami*/}
          <Route path="/business/admin-profile/AdminPaymentform" element={<AdminPaymentForm />} />
          {/* Ostatní */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/unsubscribe" element={<UnsubscribeEmail />} />

          <Route path="/doc" element={<ApiDoc />} />
          <Route path="/" element={<MainPage />} />
          <Route path="/termsAndConditions" element={<TermsAndConditions />} />
          <Route path="/cookiePage" element={<CookiesPage />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
          <Route path="/not-found" element={<NotFound />} />

        </Routes>

        <Footer />
      </Router>
    </AuthProvider>
  );
};

export default App;